import { CssBaseline, ThemeProvider } from "@mui/material";
import Projects from "./scenes/projects";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ColorModeContext, useMode } from "./theme/theme";
import RequireAuth from "./security/RequireAuth";
import { Designer } from "./scenes/designer";
import Project from "./scenes/project";
import Scenario from "./scenes/scenario";
import Billing from "./scenes/billing";
import PurchaseHistory from "./scenes/purchase-history";
import SetPassword from "./scenes/set-password";
import Team from "./scenes/team";

const ProtectedRoutes = () => (
  <RequireAuth debug={false}>
    <Routes>
      <Route path="*" element={<Projects />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/:id" element={<Project />} />
      <Route path="/scenarios/:id" element={<Scenario />} />
      <Route path="/designer" element={<Designer />} />
      <Route path="/billing" element={<Billing />} />
      <Route path="/purchase-history" element={<PurchaseHistory />} />
      <Route path="/team" element={<Team />} />
    </Routes>
  </RequireAuth>
);

function App() {
  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="*" element={<ProtectedRoutes />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
